import { render } from "./chatPage.vue?vue&type=template&id=14aceb47"
import script from "./chatPage.vue?vue&type=script&lang=js"
export * from "./chatPage.vue?vue&type=script&lang=js"

import "./chatPage.vue?vue&type=style&index=0&id=14aceb47&lang=scss"

import exportComponent from "D:\\Git\\思途茶业\\思途茶业pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__